import { render } from "./assignedWorker.vue?vue&type=template&id=6c65cbc4"
import script from "./assignedWorker.vue?vue&type=script&lang=js"
export * from "./assignedWorker.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__